<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF OUTLET CATEGORY</b></h5>
    <hr />
    <div v-if="ui.showEdit">
      <b-row class="my-1">
        <b-col md="4">
          <label for="input-default"> {{ formEdit.title }}<span class="danger-new"> *</span></label>
          <b-form-input
            v-model="formEdit.name"
            id="input-horizontal"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row class="my-1">
        <b-col md="3">
          <label for="input-default">Outlet Category <span class="danger-new"> *</span></label>
          <b-form-input
            v-model="form.name"
            id="input-horizontal"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-col>

        <b-col md="3">
          <label for="input-default">Sub Outlet Name</label>
          <b-row v-for="(sub, index) in data.suboutlet" :key="index">
            <b-col sm="10">
              <b-form-input
                v-model="sub.name"
                :id="`input-horizontal`"
                class="input-new"
                :type="`text`"
              ></b-form-input>
            </b-col>
            <b-button
              variant="danger"
              v-if="data.suboutlet.length > 1"
              size="s"
              @click="removeCat(index)"
              >x</b-button>
          </b-row>
        </b-col>
        <b-col sm="1" style="padding-top:27px;">
          <b-button variant="primary" size="s" @click="test">+</b-button>&nbsp;
        </b-col>

        <b-col md="3">
          <label for="input-default">Outlet Category Type</label>
          <b-row v-for="(sub2, index) in data.typeoutlet" :key="index">
            <b-col md="10">
              <b-form-input
                v-model="sub2.name"
                :id="`input-horizontal2`"
                class="input-new"
                :type="`text`"
              ></b-form-input>
            </b-col>
            <b-button
              variant="danger"
              v-if="data.typeoutlet.length > 1"
              size="s"
              @click="removeCatType(index)"
              >x</b-button>
          </b-row>
        </b-col>
        <b-col sm="1" style="padding-top:27px;">
          <b-button variant="primary" size="s" @click="test2">+</b-button>&nbsp;
        </b-col>
      </b-row>
    </div>
    <br><br>
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="m" @click="submitEditSub" v-if="ui.showEdit">Edit Outlet</b-button>
        <b-button variant="primary" size="m" @click="onClickAdd" v-else>Create Outlet</b-button>
      </b-col>
    </b-row>
    <br><br>

    <TableOutletIndex
      :fields="fields.fields"
      :items="items"
      @edit="onEdit($event)"
      @delete="onDel"
      @editSub="onEditSub($event)"
    />
  </b-card>
</template>

<script>
import TableOutletIndex from "@/table/admin/outlet/TableOutletIndex";

export default {
  data() {
    return {
      items: [],
      data: {
        suboutlet: [],
        typeoutlet: []
      },
      ui: {
        showEdit: false
      },
      form: {
        name: "",
        id: null,
        suboutlet: [],
        typeoutlet: []
      },
      formEdit: {
        name: "",
        sub_outlet_id: null
      },
      error: {
        name: ""
      },
      fields: {
        fields: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Category Name",
            key: "name",
            sortable: true
          },
          {
            label: "Sub Category Name",
            key: "suboutlet",
            sortable: true
          },
          {
            label: "Outlet Category Type",
            key: "typeoutlet",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  mounted () {

  },
  created() {
    this.getOutlet();
    this.test();
    this.test2();
  },
  methods: {
    onDel() {
      this.getOutlet();
    },
    test() {
      // this.form.suboutlet.push({ name: "", id: null, status: "1" });
      this.data.suboutlet.push({ name: "", id: null, status: "1" });
    },
    test2() {
      // this.form.typeoutlet.push({ name: "", id: null, status: "1"});
      this.data.typeoutlet.push({ name: "", id: null, status: "1"});
    },
    removeCat(index) {
      if (this.form.suboutlet[index]) {
        this.form.suboutlet[index].status = "3";
      }
      this.data.suboutlet.splice(index, 1);
    },
    removeCatType(index) {
      if (this.form.typeoutlet[index]) {
        this.form.typeoutlet[index].status = "3";
      }
      this.form.typeoutlet.splice(index, 1);
    },

    onClickAdd() {
      this.error.name = "";
      this.checkForm();

      let suboutlet = [];
      let typeoutlet = [];

      this.data.suboutlet.forEach(item => {
        if (item.status === "1") {
          this.form.suboutlet.push({
            sub_outlet_id: item.id,
            name: item.name,
            status: item.status
          });
        }
      });
      this.data.typeoutlet.forEach(item => {
        if (item.status === "1") {
          this.form.typeoutlet.push({
            sub_outlet_id: item.id,
            name: item.name,
            status: item.status
          });
        }
      });

      this.form.suboutlet.forEach(item => {
        if (item.name) {
          suboutlet.push({
            sub_outlet_id: item.id ? item.id : null,
            name: item.name,
            status: item.status
          });
        }
      });
      this.form.typeoutlet.forEach(item2 => {
        if (item2.name) {
          typeoutlet.push({
            sub_outlet_id: item2.id ? item2.id : null,
            name: item2.name,
            status: item2.status
          });
        }
      });
      

      const form = {
        name: this.form.name,
        suboutlet: suboutlet,
        typeoutlet: typeoutlet,
        outlet_id: this.form.id
      };
      this.$store.dispatch("createOutlet", form).then(res => {
        if (res.data.response.code === 1) {
          this.form.name = "";
          this.form.id = null;
          this.form.suboutlet = [{ name: "", id: null, status: "1" }];
          this.form.typeoutlet = [{ name: "", id: null, status: "1" }];
          this.data.suboutlet = [{ name: "", id: null, status: "1" }];
          this.data.typeoutlet = [{ name: "", id: null, status: "1" }];
          // this.test();
          this.getOutlet();
        }
      });
    },

    getOutlet() {
      this.items = [];
      this.$store.dispatch("getOutlet").then(res => {
        if (res.data.response.code === 100) {
          let no = 0;
          res.data.data.forEach(element => {
            no = no + 1;
            let new_suboutlet = [];
            let typeoutlet = [];
            if (element.sub_outlet.length > 0 || element.sub_outlet !== undefined ) {
              element.sub_outlet.forEach(element2 => {
                new_suboutlet.push({
                  name: element2.name,
                  id: element2.sub_outlet_id
                });
              });
            }
            if (element.typeoutlet.length > 0 || element.typeoutlet !== undefined ) {
              element.typeoutlet.forEach(element3 => {
                typeoutlet.push({
                  name: element3.name,
                  outlet_id: element3.outlet_id,
                  id: element3.sub_outlet_id
                });
              });
            }

            this.items.push({
              no: no,
              name: element.name,
              id: element.outlet_id,
              suboutlet: new_suboutlet,
              typeoutlet: typeoutlet
            });
          });
          this.totalRows = this.items.length;
        }
      });
    },
    checkForm: function(e) {
      if (this.form.name) return true;
      this.error.name = "";
      if (!this.form.name) this.error.name = "Outlet Category required.";
      e.preventDefault();
    },

    onEdit(index) {
      this.form.name = this.items[index].name;
      this.form.id = this.items[index].id;
      if (this.items[index].suboutlet.length > 0) {
        this.form.suboutlet = [];
        this.data.suboutlet = [];
        this.items[index].suboutlet.forEach(item => {
          this.form.suboutlet.push({
            name: item.name,
            id: item.id,
            status: "2"
          });
          this.data.suboutlet.push({
            name: item.name,
            id: item.id,
            status: "2"
          });
        });
      } else {
        this.form.suboutlet = [];
        this.data.suboutlet = [];
        this.form.suboutlet.push({
            name: "",
            id: "",
            status: "1"
          });
        this.data.suboutlet.push({
            name: "",
            id: "",
            status: "1"
          });
      }
      if (this.items[index].typeoutlet.length > 0) {
        this.form.typeoutlet = [];
        this.data.typeoutlet = [];
        this.items[index].typeoutlet.forEach(item2 => {
          this.form.typeoutlet.push({
            name: item2.name,
            outlet_id: item2.outlet_id,
            sub_outlet_id: item2.sub_outlet_id,
            status: "2"
          });
          this.data.typeoutlet.push({
            name: item2.name,
            outlet_id: item2.outlet_id,
            sub_outlet_id: item2.sub_outlet_id,
            status: "2"
          });
        });
      } else {
        this.form.typeoutlet = [];
        this.data.typeoutlet = [];
        this.form.typeoutlet.push({
            name: "",
            outlet_id: "",
            sub_outlet_id: "",
            status: "1"
          });
        this.data.typeoutlet.push({
            name: "",
            outlet_id: "",
            sub_outlet_id: "",
            status: "1"
          });
      }
    },
    onEditSub (data) {
      this.ui.showEdit = true
      this.formEdit.name = data.name;
      this.formEdit.sub_outlet_id = data.id;
      this.formEdit.title = data.title;
    },
    submitEditSub() {
      this.$store.dispatch("createSubOutlet", this.formEdit).then(res => {
        if (res.data.response.code === 1) {
          // this.test();
          this.ui.showEdit = false
          this.getOutlet();
        }
      });
    }
  },
  components: {
    TableOutletIndex
  }
};
</script>
<style lang="css" scoped></style>
